import PropTypes from 'prop-types';
import React from 'react';
export default function Title(_ref) {
  var {
    title
  } = _ref;
  return /*#__PURE__*/React.createElement("title", null, title);
}
Title.propTypes = {
  title: PropTypes.string.isRequired
};